<template>
	<v-dialog
			persistent
			v-model="$store.state.admin.showImportDialog"
			width="750px">
		<template v-slot:activator="{ on }">
			<v-btn	class="customVBtn"
					:block="$_admnImprtDlg_styleStepperActionButtonBlock"
					:color="$_admnImprtDlg_styleStepperActionButtonColor"
					:dark="$_admnImprtDlg_styleStepperActionButtonDark"
					:depressed="$_admnImprtDlg_styleStepperActionButtonDepressed"
					:elevation="$_admnImprtDlg_styleStepperActionButtonElevation"
					:large="$_admnImprtDlg_styleStepperActionButtonLarge"
					:light="$_admnImprtDlg_styleStepperActionButtonLight"
					:outlined="$_admnImprtDlg_styleStepperActionButtonOutlined"
					:rounded="$_admnImprtDlg_styleStepperActionButtonRounded"
					:small="$_admnImprtDlg_styleStepperActionButtonSmall"
					:text="$_admnImprtDlg_styleStepperActionButtonFlat"
					v-on="on">
				Import
			</v-btn>
		</template>
		<v-card class="customVCard">
			<template v-if="!isFalse(errorMessage_)">
				<v-row>
					<v-col>
						<span style="color:red" v-text="errorMessage_" />
					</v-col>
				</v-row>
			</template>
			<v-row>
				<v-col>
					<v-text-field
							placeholder="CSV ID"
							hide-details
							outlined
							v-model="importId_" />
				</v-col>
			</v-row>
			<v-card-actions>
				<v-row dense justify="center">
					<v-col cols="auto">
						<v-btn	class="customVBtn"
								:disabled="isFalse(importId_)"
								@click="$_admnImprtDlg_import(contentKey)">
							Import
						</v-btn>
					</v-col>
					<v-col cols="auto">
						<v-btn	class="customVBtn"
								@click="$_admnImprtDlg_close()">
							Close
						</v-btn>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		name: 'AdminImportDialog',
		props: {
			contentKey: String,
			contents: Object,
			inits: Object
		},
		data() {
			return {
				importId_: null,
				errorMessage_: null
			}
		},
		computed: {
			$_admnImprtDlg_styleStepperActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepperActionButton')
			},
			$_admnImprtDlg_styleStepperActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_admnImprtDlg_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_admnImprtDlg_styleStepperActionButtonColor() {
				const self_ = this;
				const actionButton_ =self_.$_admnImprtDlg_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.color)
			},
			$_admnImprtDlg_styleStepperActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_admnImprtDlg_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_admnImprtDlg_styleStepperActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_admnImprtDlg_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_admnImprtDlg_styleStepperActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_admnImprtDlg_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_admnImprtDlg_styleStepperActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_admnImprtDlg_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_admnImprtDlg_styleStepperActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_admnImprtDlg_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_admnImprtDlg_styleStepperActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_admnImprtDlg_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_admnImprtDlg_styleStepperActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_admnImprtDlg_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_admnImprtDlg_styleStepperActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_admnImprtDlg_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_admnImprtDlg_styleStepperActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_admnImprtDlg_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			}
		},
		methods: {
			$_admnImprtDlg_import(contentKey) {
				const self_ = this;

				let data_ = self_.getAdminState('data')

				Promise.resolve().then(() => {
					return self_.ipCliGetAppInputsById(self_.importId_)
				}).then(result => {
					const rows_ = result.data.rows;

					let count_ = 0;
					rows_.forEach(row => {
						// user
						if(contentKey == 'resetPassword' || contentKey == 'changeUserGroup' || contentKey == 'changeUserOption' || contentKey == 'changeUserStatus' || contentKey == 'deleteUser') {
							row.uid = self_.adminGetUser(row.username, 'uid')
							row.fullName = self_.adminGetUser(row.username, 'full_name')
						}
						// user group
						if(contentKey == 'deleteGroup') {
							row.groupName = self_.adminGetGroup(row.code, 'name')
						}
						if(contentKey == 'changeUserGroup') {
							row.groupName = self_.adminGetGroup(row.groupCode, 'name')
						}
						// point voucher
						if(contentKey == 'createVoucher') {
							row.criteriumName = self_.adminGetCriterium(row.criteriumCode, 'name')
						}

						data_[count_+1] = row;
						count_++;
					})

					self_.setAdminState('data', data_)

					self_.$emit('imported')

					self_.$_admnImprtDlg_close()
				})
			},
			$_admnImprtDlg_close() {
				const self_ = this;

				self_.setAdminState('showImportDialog', false)
			}
		}
	}
</script>

<style scoped>
</style>
